import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import appUrl from '../../appUrl';
import { Modal, Form, Button, Spinner, Card, CardBody, Row, Col, ListGroup, ListGroupItem, Badge, Image } from 'react-bootstrap';
import { FaFilePdf, FaArrowLeft, FaEnvelope, FaMapMarkerAlt, FaCheckCircle, FaTimesCircle, FaClipboardList } from 'react-icons/fa';
import './Profile.css';
import ImageCarousel from '../Carousel';

function BusinessProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [dataLoading, setDataLoading] = useState(false);
  const [business, setBusiness] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({ type: "", content: [] });

  const id = queryParams.get('id');
  const userId = queryParams.get('user');
  const AppUrl = appUrl();

  useEffect(() => {
    const fetchBusiness = async () => {
      try {
        setDataLoading(true);
        const token = localStorage.getItem('token');
        const response = await fetch(id ? `${AppUrl}/getbusiness?id=${id}` : `${AppUrl}/getbusiness?userId=${userId}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        setBusiness(data.data);
      } catch (error) {
        console.error(error);
      } finally {
        setDataLoading(false);
      }
    };

    fetchBusiness();
  }, [AppUrl, id, userId]);

  const handleModal = (type) => {
    setModalContent({ type, content: type === 'business_images' ? business.business_images : business.documents });
    setShowModal(true);
  };

  const convertTo12HourFormat = (time) => {
    if (!time) return 'N/A';
    const localTime = new Date(time).toLocaleString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
    return localTime;
  };

  return (
    <>
      {dataLoading ? (
        <div className="loading-spinner">
          <Spinner animation="border" role="status" />
        </div>
      ) : !business ? (
        <div className='flex-center h-100'>
          <p className='text-xl'>No Business found</p>
        </div>
      ) : (
        <div className="container">
          <div className="flex items-center pb-2 justify-between">
            <div className='back-button' onClick={() => navigate(-1)}>
              <FaArrowLeft />
            </div>
          </div>

          <Card className="shadow-sm p-3 mt-2 mb-4 bg-white rounded">
            <CardBody>
              <Row>
                <Col md={4} className="text-center">
                  <Image
                    src={business.flyer || business.business_images?.[0] || '/images/default-business.png'}
                    alt="Business"
                    className="rounded img-fluid mb-3"
                    style={{ width: '80%' }}
                  />
                  <h5 className="text-capitalize mb-2">Business Name: {business.business_name}</h5>
                  <Badge className='py-2 px-3 text-lg text-capitalize' bg={business.status === 'approved' ? 'success' : business.status === 'rejected' ? 'danger' : 'warning'}>
                    {business.status}
                  </Badge>

                  {business.service_timing?.length > 0 && (
                    <div className="mt-4">
                      <h5 className='mb-2'>Business Service Timings:</h5>
                      <ListGroup>
                        {business.service_timing.map((timing, index) => (
                          <ListGroupItem className='flex-center' key={index}>
                            <p className='font-bold'>{timing.dayname.slice(0, 3)}:</p>
                            <p className='mx-1'>
                              {timing.is_closed ? 'Closed' : timing.is24hour ? '24 Hours' : `${convertTo12HourFormat(timing.start_time)} - ${convertTo12HourFormat(timing.end_time)}`}
                            </p>
                          </ListGroupItem>
                        ))}
                      </ListGroup>
                    </div>
                  )}
                </Col>

                <Col md={8}>
                  <ListGroup className='px-2'>
                    <ListGroupItem><FaEnvelope /> {business.email}</ListGroupItem>
                    {business.location && (
                      <ListGroupItem>
                        <FaMapMarkerAlt /> {`${business.location.area_street_locality}, ${business.location.city}`}
                      </ListGroupItem>
                    )}
                    <ListGroupItem><FaClipboardList /> Service Type: {business.business_offered}</ListGroupItem>
                    {business.is_blocked !== undefined && (
                      <ListGroupItem>
                        <p className='inline'>Status: </p>
                        {business.is_blocked ? (
                          <FaTimesCircle className="text-danger" />
                        ) : (
                          <FaCheckCircle className="text-success" />
                        )} {business.is_blocked ? 'Blocked' : 'Active'}
                      </ListGroupItem>
                    )}
                    <ListGroupItem>Provider Type: {business.provider_type}</ListGroupItem>
                    <ListGroupItem>Service Categories : ['Cyber hub', 'Data Analaysis', 'Testing']</ListGroupItem>
                    <ListGroupItem>Created At : {new Date(business?.createdAt).toLocaleDateString()} </ListGroupItem>
                  </ListGroup>



                  <div className="flex flex-wrap gap-1 px-2 mt-4">
                    <h5 className='mb-1'>Description:</h5>
                    <Form.Control style={{ height: '12.5rem' }} as="textarea" value={business.description || 'No description available.'} readOnly />
                  </div>


                </Col>

                {/*plan card */}
                <div className='plan-card-box'>

                  {business.plan?.length > 0 && (
                    <div className="flex-center gap-2 mt-4">
                      {/* <h5 className='mb-1'>Plans:</h5> */}
                      {business.plan.map((plan, index) => (
                        <ListGroup key={index} className="plan-card flex-center flex-col gap-1">

                          <h6 className=''>Name: <strong>{plan.plan_name}</strong></h6>
                          <Image
                            src={business.flyer || business.business_images?.[0] || '/images/default-business.png'}
                            alt="Business"
                            className="rounded"
                            style={{ width: '80%', height: "72%", objectFit: "auto-fit" }}
                          />
                          <h6 className=''>Price: <strong>${plan.price} {plan.isNegotiable ? '(Negotiable)' : ''}</strong></h6>
                          <h6 className=''>Description: <strong>{plan.description}</strong></h6>

                          <Badge className='plan-nego text-capitalize' style={{ width: '50%' }} bg={business.status === 'approved' ? 'success' : business.status === 'rejected' ? 'danger' : 'warning'}>
                            {business.status}
                          </Badge>
                        </ListGroup>
                      ))}
                    </div>
                  )}
                </div>

              </Row>
            </CardBody>
          </Card>

          <div className='flex justify-content-end'>
            <div className='flex-center gap-1'>
              <Button onClick={() => handleModal('business_docs')} size='sm' style={{ width: '10rem' }} className='view-details-button-lg px-3 py-2'>
                View Documents
              </Button>
              <Button onClick={() => handleModal('business_images')} size='sm' style={{ width: '10rem' }} className='view-details-button-lg px-3 py-2'>
                View Images
              </Button>



            </div>
          </div>
        </div>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{modalContent.type === 'business_images' ? 'Business Images' : 'Business Documents'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalContent.type === 'business_images' ? <ImageCarousel data={modalContent.content} /> :
            <div className='flex-center'>
              {modalContent.content.map((doc, index) => (
                <Col key={index} xs={12} md={6} className="my-2">
                  <Link to={doc} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <Card className="flex-center flex-col document_card shadow">
                      <FaFilePdf size={50} color="#d32f2f" />
                      <Card.Text className="mt-3 text-dark">{`Doc_${index + 1}.pdf`}</Card.Text>
                    </Card>
                  </Link>
                </Col>
              ))}
            </div>
          }
        </Modal.Body>
      </Modal>
    </>
  );
}

export default BusinessProfile;
